import React, { useRef, useState } from 'react'

import Header from '../header/Header';
import Home from '../home/Home';
import Services from '../services/Services';
import Technology from '../technology/Technology';
import About from '../about/About';
import Contact from '../contact/Contact';

import './app.css';

function App() {
  const homeRef = useRef(null)
  const servicesRef = useRef(null)
  const technologyRef = useRef(null)
  const aboutRef = useRef(null)

  const [isContactOpen, setIsContactOpen] = useState(false);

  const pages = [{
    ref: homeRef,
    title: "Home"
  }, {
    ref: servicesRef,
    title: "Services"
  }, {
    ref: technologyRef,
    title: "Technology"
  }, {
    ref: aboutRef,
    title: "Company"
  }]

  return (
    <div className="app">
      <div className="stars-background"></div>
      <Header pages={pages} onContactClick={() => setIsContactOpen(true)} />
      <main className="page-container">
        <Home pageRef={homeRef} onContactClick={() => setIsContactOpen(true)} />
        <Services pageRef={servicesRef}/>
        <Technology pageRef={technologyRef}/>
        <About pageRef={aboutRef}/>
      </main>
      <Contact isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} />
    </div>
  );
}

export default App;
